
const IDCode = "";
const ChapterID ="";
const isLogin = false;
const viewVideo = false;//可以无限制看视频 
 export default
 {
   IDCode,
   ChapterID,
   isLogin,
   viewVideo
 }





// WEBPACK FOOTER //
// ./src/components/tool/Global.vue